eshopApp.factory('quickModal', ['$uibModal' , function($uibModal){

	var quickModal = {};

	var dialogTemplates = {
		confirmation : 'modal_confirm.html',
		notification : 'modal_message.html'
	}

	// Crete a dialog
	quickModal.set = function(type, message, size) {
		return $uibModal.open({
			//scope: $scope,
			templateUrl: dialogTemplates[type],
			controller: 'QuickModalsController',
			size: size, // Bootstrap modal sizes: md, lg, etc.
			resolve: {
				message: function() {
					return message;
				}
			},
		});
		
	}

	return quickModal;
}]);